export const environment = {
  apiUrl: 'https://development.api.thumpergames.com/api/v1/',
  contactEmail: 'contact@thumpersoftware.com',
  discordBotClientId: '1517947420837675180',
  discordBotPermissions: '2415921159',
  enviromentPrefix: 'Dev',
  MatchmakingViewPolling: 10,
  LogViewPolling: 10,
  LogViewRecordsPerApplicationLimit: 1000,
  thumperChessApplicationName: 'Thumper Chess',
  thumperChessRankedGameModeId: 2,
  LeaderboardViewDefaultRows: 100,
  production: false,
};
